module.exports = __webpack_public_path__ + "static/media/ap2.9a3115eb.jpg";